import React from 'react';
import { Form, Row, SonForm, SubmitButton, Textarea, useForm } from '../../../_lib/Form2';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

function RegistrationEmailEdit({ form }: { form: SonForm<any> }) {
  const { t } = useSonTranslation('RegistrationEmail');
  const { formProps, params, fetchState } = useForm({ form });

  return (
    <Form {...formProps}>
      <Row>
        <Textarea
          label={t('headline')}
          helpText={t('edit.inputs.helpText')}
          param={params.getByName('son_portal_registration_email')}
        />
      </Row>
      <SubmitButton
        buttonLabel={t('Form:save')}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}

export const RegistrationEmailEditView = asFetchableView(RegistrationEmailEdit);
